module.exports = __webpack_public_path__ + "img/icon-fom-sales-analytics.ab8553e7.png";